import { businessConfig } from '../../../config/businessConfig';

export default function Hero({ onConsultation }) {
  return (
    <section className="hero" id="inicio">
      <div className="container hero__layout">
        <div className="hero__content reveal">
          <p className="eyebrow">Estudio de uñas · Atención personalizada</p>
          <h1>{businessConfig.businessName}</h1>
          <p className="hero__lead">{businessConfig.tagline}</p>
          <div className="hero__actions">
            <button className="button button--gold" type="button" onClick={onConsultation}>Consultar disponibilidad</button>
            <a className="button button--line" href="#servicios">Conocer servicios</a>
          </div>
          <p className="hero__note">Una experiencia dedicada, tranquila y cuidada en cada detalle.</p>
        </div>
        <div className="hero__visual" aria-label="Espacio reservado para una fotografía real del estudio">
          {businessConfig.assets.heroImage ? (
            <img
              src={businessConfig.assets.heroImage}
              alt="Aplicación de esmalte durante una atención de manicure"
              width="1024"
              height="1280"
              decoding="async"
              fetchPriority="high"
            />
          ) : (
            <div className="media-pending media-pending--hero">
              <span>Fotografía real</span>
              <small>pendiente de incorporar</small>
            </div>
          )}
          <div className="hero__seal" aria-hidden="true"><span>MV</span><small>2024</small></div>
        </div>
      </div>
      <a className="hero__scroll" href="#historia"><span>Descubrir</span><i /></a>
    </section>
  );
}
